import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { municipalities } from '../../../data/municipalities';

export function ProcessorStep1BasicInfo({ formData, handleInputChange, handlePhoneChange }) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-amber-900 border-b-2 border-amber-200 pb-2">
        Basic Business Information
      </h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="nameOfBusiness">Business Name *</Label>
          <Input
            id="nameOfBusiness"
            value={formData.nameOfBusiness}
            onChange={(e) => handleInputChange('nameOfBusiness', e.target.value)}
            placeholder="Enter business name"
            required
          />
        </div>
        <div>
          <Label htmlFor="nameOfTheOwner">Owner Name *</Label>
          <Input
            id="nameOfTheOwner"
            value={formData.nameOfTheOwner}
            onChange={(e) => handleInputChange('nameOfTheOwner', e.target.value)}
            placeholder="Enter owner's full name"
            required
          />
        </div>
        <div>
          <Label htmlFor="typeOfBusiness">Business Type *</Label>
          <Select value={formData.typeOfBusiness} onValueChange={(value) => handleInputChange('typeOfBusiness', value)}>
            <SelectTrigger>
              <SelectValue placeholder="Select business type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Sole Proprietorship">Sole Proprietorship</SelectItem>
              <SelectItem value="Corporation">Corporation</SelectItem>
              <SelectItem value="Association">Association</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="statusOfBusiness">Business Status</Label>
          <Select value={formData.statusOfBusiness} onValueChange={(value) => handleInputChange('statusOfBusiness', value)}>
            <SelectTrigger>
              <SelectValue placeholder="Select business status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Inherited">Inherited</SelectItem>
              <SelectItem value="Newly Established">Newly Established</SelectItem>
              <SelectItem value="Established by the owner not inherited">Established by the owner not inherited</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="address">Business Address</Label>
          <Input
            id="address"
            value={formData.address}
            onChange={(e) => handleInputChange('address', e.target.value)}
            placeholder="Complete business address"
          />
        </div>
        <div>
          <Label htmlFor="addressOwner">Owner Address</Label>
          <Input
            id="addressOwner"
            value={formData.addressOwner}
            onChange={(e) => handleInputChange('addressOwner', e.target.value)}
            placeholder="Owner's address"
          />
        </div>
        <div>
          <Label htmlFor="municipality">Municipality</Label>
          <Select value={formData.municipality} onValueChange={(value) => handleInputChange('municipality', value)}>
            <SelectTrigger>
              <SelectValue placeholder="Select municipality" />
            </SelectTrigger>
            <SelectContent>
              {municipalities.map(municipality => (
                <SelectItem key={municipality} value={municipality}>
                  {municipality}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label htmlFor="barangay">Barangay</Label>
          <Input
            id="barangay"
            value={formData.barangay}
            onChange={(e) => handleInputChange('barangay', e.target.value)}
            placeholder="Enter barangay"
          />
        </div>
        <div>
          <Label htmlFor="contactNumbers">Contact Numbers</Label>
          <Input
            id="contactNumbers"
            type="tel"
            inputMode="numeric"
            maxLength={11}
            value={formData.contactNumbers}
            onChange={(e) => handlePhoneChange(e.target.value.replace(/\D/g, ''))}
            placeholder="e.g., 09123456789"
            title="Please enter an 11-digit Philippine mobile number"
          />
        </div>
        <div>
          <Label htmlFor="lengthOfBusinessOperationInYears">Years in Operation</Label>
          <Input
            id="lengthOfBusinessOperationInYears"
            type="number"
            value={formData.lengthOfBusinessOperationInYears}
            onChange={(e) => handleInputChange('lengthOfBusinessOperationInYears', e.target.value)}
            placeholder="e.g., 5"
            min="0"
          />
        </div>
        <div>
          <Label htmlFor="numberOfEmployees">Number of Employees</Label>
          <Input
            id="numberOfEmployees"
            type="number"
            value={formData.numberOfEmployees}
            onChange={(e) => handleInputChange('numberOfEmployees', e.target.value)}
            placeholder="e.g., 10"
            min="0"
          />
        </div>
        <div>
          <Label htmlFor="type">Employment Type</Label>
          <Input
            id="type"
            value={formData.type}
            onChange={(e) => handleInputChange('type', e.target.value)}
            placeholder="e.g., Regular, Contractual, On-call, Part-time"
          />
        </div>
        <div>
          <Label htmlFor="initialInvestment">Initial Investment (₱)</Label>
          <Input
            id="initialInvestment"
            type="number"
            value={formData.initialInvestment}
            onChange={(e) => handleInputChange('initialInvestment', e.target.value)}
            placeholder="e.g., 500000"
            min="0"
            step="0.01"
          />
        </div>
        <div>
          <Label htmlFor="averageAnnualGrossIncome">Average Annual Gross Income (₱)</Label>
          <Input
            id="averageAnnualGrossIncome"
            type="number"
            value={formData.averageAnnualGrossIncome}
            onChange={(e) => handleInputChange('averageAnnualGrossIncome', e.target.value)}
            placeholder="e.g., 2000000"
            min="0"
            step="0.01"
          />
        </div>
        <div>
          <Label htmlFor="latitude">Latitude</Label>
          <Input
            id="latitude"
            type="number"
            step="any"
            value={formData.latitude}
            onChange={(e) => handleInputChange('latitude', e.target.value)}
            placeholder="e.g., 9.6167"
          />
        </div>
        <div>
          <Label htmlFor="longitude">Longitude</Label>
          <Input
            id="longitude"
            type="number"
            step="any"
            value={formData.longitude}
            onChange={(e) => handleInputChange('longitude', e.target.value)}
            placeholder="e.g., 123.8667"
          />
        </div>
      </div>
    </div>
  );
}

ProcessorStep1BasicInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handlePhoneChange: PropTypes.func.isRequired,
};
